import React, { useEffect, useState } from 'react';
import { CargarPlanes } from './CargarPlanes';
import { CargarItemsPlan, CargarItemsPlanesDB } from './CargarItemsPlan';
import ContenedorAnimacion from './ContenedorAnimacion';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PrecioConFormato from './PrecioConFormato';
import Planes from '../types/Planes';

//import logografico from './../assets/images/logo_vidaplus_transparente_200x60.png'
//import logotexto from './../assets/images/logotipo.jpg'

const MostrarPlanes: React.FC = () => {

  const [planesData, setPlanesData] = useState<Planes[]>([]);
  const [itemsplanesData, setItemsPlanesData] = useState<any[]>([]);

  useEffect(() => {
    const fetchPlanes = async () => {
      const planes = await CargarPlanes();

    // recorrer el resultado y transformar importes string en float guardar todo en un nuevo arreglo
    planes.forEach((plan: Planes) => {
        plan.price = parseFloat(plan.price.toString());
        plan.pricedebito = parseFloat(plan.pricedebito.toString());
    });
    
      setPlanesData(planes);
    };

    const fetchItemsPlanes = async () => {
      const items = await CargarItemsPlanesDB();
      setItemsPlanesData(items);
    };

    fetchPlanes();
    fetchItemsPlanes();
  }, []);

  return (
        <div className="flex flex-row justify-evenly items-start flex-wrap">
        {planesData.map(plan => (
            (plan.mostrar === "S" || plan.mostrar === "W") && (
            <ContenedorAnimacion key={plan.id} animation='zoomIn' duration={800} delay={1} className="">                
                <div className={`mx-2 my-2 sm:m-4 flex flex-col justify-start items-center text-gray-500 border-2 border-stone-500 rounded-b-xl shadow-md shadow-vp-gris min-w-[150px] max-w-[240px] group transition hover:shadow-md hover:shadow-vp-azulclaro`}>
                    <div className={`flex flex-row flex-nowrap justify-around items-center ${plan.headercolor} ${plan.headercolorhover} transition w-full overflow-visible max-h-[50px] `}>
                        <div className={`flex items-start text-truncate-title `}>
                            <h3 className="font-myriad-pro text-lg font-regular text-black text-truncate-title ">
                                <span className='font-bold text-vp-azul group-hover:text-white'>{plan.title.split(' ')[0]}</span>
                                <span className='font-bold text-vp-verde group-hover:text-white'>{plan.title.split(' ')[1]}</span>
                                {((plan.title.split(' ')[2]) === "Senior" || (plan.title.split(' ')[2]) === "Odonto") && (
                                    <span className='font-bold  group-hover:text-white'>{plan.title.split(' ')[2]}</span>
                                )}
                            </h3>                            
                        </div>
                        <div className={`flex justify-center items-center w-[60px] h-[60px] rounded-full border-2 border-vp-azul object-contain bg-white group-hover:shadow-lg group-hover:shadow-vp-gris group-hover:scale-110 transition relative z-10`}>
                            <h3 className="font-myriad-pro text-xl font-bold text-black text-truncate-title">
                                {plan.codigoplan}  
                            </h3>  
                        </div>
                    </div>
                    <div className="min-h-36 h-36 sm:min-h-32 sm:h-32 flex flex-col justify-around items-center content-start text-left text-sm px-1 text-truncate-description border-br-xl group-hover:bg-stone-100 transition">
                        <p className="font-myriad-pro text-sm font-regular text-vp-gris text-truncate-description px-1 group-hover:text-black group-hover:bg-stone-100 transition">
                            {plan.description}
                        </p>
                        <p className="text-center font-metropolis font-bold text-2xl group-hover:text-black">$ <PrecioConFormato precio={plan.pricedebito} decimales={2} /><span className="font-normal text-sm text-stone-400 group-hover:text-stone-600">/mes</span></p>
                    </div>
                    <div className="rounded-b-xl group-hover:text-black group-hover:bg-stone-100 transition w-full h-full pb-2">
                        {itemsplanesData.filter(item => item.idplan === plan.id).map(item => (
                            <div key={item.id} className="flex flex-row flex-nowrap justify-start items-center w-full pl-2">
                                <CheckCircleOutlineIcon className='text-vp-verde pr-1' />
                                <p className="font-metropolis font-normal text-sm">{item.title}</p>
                            </div>
                            ))}
                    </div>
                </div>
            </ContenedorAnimacion>)
        ))}
        </div>
    );
};

export default MostrarPlanes;


/*<div key={servicio.id} className="bg-gray-100 p-4 rounded-lg">
<img src={servicio.imageSrc} alt={servicio.title} className="w-full h-40 object-cover mb-4 rounded-lg" />
<h2 className="text-xl font-bold mb-2">{servicio.title}</h2>
<p className="text-gray-700 mb-2">{servicio.description}</p>
</div>*/

/* <ContenedorAnimacion key={plan.id} animation='zoomIn' duration={800} delay={40} className="justify-center">
</ContenedorAnimacion>
*/